import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-po-table',
  templateUrl: './po-table.component.html',
  styleUrls: ['./po-table.component.css']
})
export class PoTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
